import { useRPCContext } from "../../../contexts/RPCContext.js";
import { useEffect } from "react";
//#region src/modules/Reports/shared/UserClientViewingReport.tsx
function UserClientViewingReport({ reportId }) {
	const { rpcService } = useRPCContext();
	useEffect(() => {
		const t = setTimeout(() => rpcService.UserClient.ViewReport.v1.call({ reportId }), 3e3);
		return () => {
			clearTimeout(t);
		};
	}, [reportId]);
	return null;
}
//#endregion
export { UserClientViewingReport };

//# sourceMappingURL=UserClientViewingReport.js.map